import { type ReactNode } from 'react'
import { Box, type BoxProps } from '../Box'
import { TextWithCapsize as Text } from '../Text/Text'
import { tabCss } from './Tab.css'

type TabProps = { isActive?: boolean; children: ReactNode } & Omit<
  BoxProps,
  'as' | 'className'
>

export function Tab({ children, isActive, ...props }: TabProps) {
  return (
    <Box as="button" className={tabCss} aria-checked={isActive} {...props}>
      {typeof children === 'string' ? (
        <Text variant={null}>{children}</Text>
      ) : (
        children
      )}
    </Box>
  )
}
